// Libraries
import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators
}  from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

// Services
import { Angular2TokenService } from 'angular2-token';

// Forms
import { FormUtils } from './../../woopa-ui/forms';

/**
 * `LoginComponent` implements the login view.
 */
@Component({
  template: require('./login.component.html')
})
export class LoginComponent implements OnInit {
  /**
   * From group for login.
   */
  public loginForm: FormGroup;
  /**
   * Flag to maintain if request is running or not.
   */
  public isLoading = false;
  /**
   * Keep current form errors.
   */
  public formErrors = {
    'email': '',
    'password': ''
  };
  /**
   * Store validation error messages.
   */
  public validationMessages = {
    'email': {
      'email': 'Formato de correo electrónico incorrecto.'
    },
    'password': {
      'required': 'Debe estar presente.'
    }
  };
  /**
   * Login errors.
   */
  public errors = [];

  /**
   * Creates a new `LoginComponent` instance.
   */
  constructor(
    private tokenService: Angular2TokenService,
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastsManager
  ) {
  }

  /**
   * Implements on init mehotd
   */
  public ngOnInit() {
    // Buid form
    this.buildForm();
  }

  /**
   * Open user session.
   */
  public login(): any {
    // Do login and redirect
    const formModel = this.loginForm.value;
    const params = {
      email: formModel.email,
      password: formModel.password,
      userType: formModel.userType
    };
    // Toggle loading flag
    this.isLoading = true;
    // Make login
    this.tokenService.signIn(params).subscribe(
      (res: any) => {
        let user = res.json().data;
        // Toggle loading flag
        this.isLoading = false;
        // If is admin redirect to home
        if (user.isAdmin) {
          this.router.navigate(['']);
        } else {
          // If is supervisor, show message
          this.toastr.warning(
            'No es posible ingresar con un perfil de supervisor a esta plataforma.',
            'Advertencia!'
          );
          // Logout
          this.tokenService.signOut();
        }
      },
      (res) => {
        const response = res.json();
        // Toggle loading flag
        this.isLoading = false;
        // Save login errors
        if (response.errors) {
          this.errors = response.errors;
        }
      }
    );
  }

  /**
   * Create login form group and controls
   */
  private buildForm(): void {
    this.loginForm = this.fb.group({
      'email': ['', Validators.email],
      'password': ['', Validators.required ],
      'userType': ['ADMIN']
    });

    this.loginForm.valueChanges
      .subscribe(data => this.onValueChanged(data));
    // (re)set validation messages now
    this.onValueChanged();
  }

  /**
   * Handles object value changes.
   * @param _data Data
   */
  private onValueChanged(_data?: any) {
    if (!this.loginForm) { return; }
    // Clear backend errors
    this.errors = [];

    // Parse form errors
    this.formErrors = FormUtils.parseErrors(this.loginForm, this.formErrors, this.validationMessages);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/public/login/login.component.ts